import { getIsOutlook, getIsDesktop, getIsWeb, getIsWord, getIsExcel, getIsPowerPoint } from "./office";
import { nrPageAction } from "./newrelic";
import { version } from "../version.json";

const getIsClassicOutlook = () => {
    if (!getIsOutlook()) return false;

    return getIsDesktop()
    && Office.context.diagnostics.platform !== Office.PlatformType.Mac;
  };

const getIsMacOutlook = () => {
    if (!getIsOutlook()) return false;

    return getIsDesktop()
    && Office.context.diagnostics.platform === Office.PlatformType.Mac;
  };

const getIsNewOutlook = () => {
    if (!getIsOutlook()) return false;

    return getIsWeb()
    && (Office.context.mailbox.diagnostics.hostName === 'newOutlookWindows'
    || Office.context.mailbox.diagnostics.hostName === 'OutlookWebApp');
  };

const getIsOutlookWeb = () => {
    if (!getIsOutlook()) return false;

    return getIsWeb()
    && Office.context.mailbox.diagnostics.hostName === 'OutlookWebApp';
  };

const getIsOffice = () => {
    return getIsWord()
    || getIsExcel()
    || getIsPowerPoint();
  };

const trackOutlookEnvironment = () => {
    try {
      let outlookEnvironment = 'unknown';

      const isClassic = getIsClassicOutlook();
      const isMac = getIsMacOutlook();
      const isNew = getIsNewOutlook();
      const isWeb = getIsOutlookWeb();
      const isOffice = getIsOffice();

      if (isClassic) {
        outlookEnvironment = 'classic-outlook';
      } else if (isWeb) {
        outlookEnvironment = 'web-outlook';
      } else if (isNew) {
        outlookEnvironment = 'new-outlook';
      } else if (isMac) {
        outlookEnvironment = 'mac-outlook';
      } else if (isOffice) {
        outlookEnvironment = 'office';
      }

      nrPageAction('outlookEnvironmentDetected', {
        outlookEnvironment,
        addonVersion: version,
      });

      console.log(`Outlook environment detected ${outlookEnvironment}, addon version ${version}`);

    } catch (error) {
      console.error('Error tracking Outlook environment:', error);
      nrPageAction('outlookEnvironmentTrackingError', {
        error: error instanceof Error ? error.message : String(error)
      });
    }
  };

export default trackOutlookEnvironment;